import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const GatheredLeatherPants = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.GatheredLeatherPants.itemName}
      name={SS23.pants.GatheredLeatherPants.itemName}
      price={SS23.pants.GatheredLeatherPants.itemPrice}
      fabric={SS23.pants.GatheredLeatherPants.itemFabric}
      src={SS23.pants.GatheredLeatherPants.sizeChart}
      divId={SS23.pants.GatheredLeatherPants.shopifyDivId}
      mainId={SS23.pants.GatheredLeatherPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.GatheredLeatherPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.GatheredLeatherPants.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default GatheredLeatherPants;
